import { render, staticRenderFns } from "./Careta.vue?vue&type=template&id=423bf946&scoped=true&"
import script from "./Careta.vue?vue&type=script&lang=js&"
export * from "./Careta.vue?vue&type=script&lang=js&"
import style0 from "./Careta.vue?vue&type=style&index=0&id=423bf946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423bf946",
  null
  
)

export default component.exports